import { render, staticRenderFns } from "./StoryblokImg.vue?vue&type=template&id=a522080a&"
import script from "./StoryblokImg.vue?vue&type=script&lang=js&"
export * from "./StoryblokImg.vue?vue&type=script&lang=js&"
import style0 from "./StoryblokImg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports